import { defineMessages } from 'react-intl';

export default defineMessages({
  label: {
    id: 'social.linkedIn.label',
    defaultMessage: 'Connect LinkedIn Profile'
  }
});
